<template>
  <VDialogV3
    id="transport-route-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localTransportRoute"
    :context-menu="localTransportRoute?.isExisting ? TransportRoutesService.contextMenu : null"
    @submit="onSubmit"
  >
    <section>
      <VSelect
        v-model="localTransportRoute.zoneFrom"
        label="Откуда"
        layout="vertical"
        required
        data-url="transportZones.getList"
      />

      <VSelect
        v-model="localTransportRoute.zoneTo"
        label="Куда"
        layout="vertical"
        required
        data-url="transportZones.getList"
      />
    </section>

    <hr>

    <section>
      <VInputNumberRusV2
        v-model="localTransportRoute.costPerKg"
        :type="Price"
        layout="vertical"
        required
        label="Цена за кг"
        :unit="localTransportRoute.costCurrency?.toString({ format: 'symbol' })"
      />

      <VInputNumberRusV2
        v-model="localTransportRoute.costPerM3"
        :type="Price"
        layout="vertical"
        required
        label="Цена за м³"
        :unit="localTransportRoute.costCurrency?.toString({ format: 'symbol' })"
      />

      <VSelect
        v-model="localTransportRoute.costCurrency"
        layout="vertical"
        label="Валюта"
        disabled
        required
        option-label="symbol"
        option-description="description"
        :options="CurrenciesService.currencies"
      />
    </section>

    <hr>

    <section>
      <VSelectV2
        v-model="localTransportRoute.vehicleType"
        layout="vertical"
        label="Тип транспорта"
        :data="vehicleTypesSource"
      />

      <VSelectV2
        :disabled="!localTransportRoute.vehicleType"
        v-model="localTransportRoute.vehicle"
        layout="vertical"
        label="Транспорт"
        :data="vehiclesSource"
      />
      <VInputNumberRusV2
        v-model="localTransportRoute.ftlCost"
        :type="Price"
        layout="vertical"
        label="Ставка за рейс"
        :unit="localTransportRoute.costCurrency?.toString({ format: 'symbol' })">
        <template #helper-text>
          Перевозка целым грузовиком, выделенным под груз. Стоимость фиксированная, независимо от веса/объёма.
        </template>
      </VInputNumberRusV2>
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import TransportRoute            from '@/domains/TransportRoutes/TransportRoute';
import TransportRoutesService    from '@/domains/TransportRoutes/TransportRoutesService';
import CurrenciesService         from '@/domains/Currencies/CurrenciesService';
import Price                     from '@/core/types/Price';

import VehicleTypesService       from "@/domains/VehicleTypes/VehicleTypesService";
import VehiclesService           from "@/domains/Vehicles/VehiclesService";
import type Vehicle from "@/domains/Vehicles/Vehicle";

export default defineComponent({
  name: 'TransportRouteCard',

  props: {
    /** ID маршрута — карточка сама загружает объект */
    id: {
      type:    Number,
      default: null,
    },
  },

  setup() {
    return {
      Price,
      CurrenciesService,
      TransportRoutesService,
    };
  },

  data() {
    return {
      localTransportRoute: undefined as unknown as TransportRoute,

      vehicleTypesSource: this.$core.loader.select(
        () => VehicleTypesService.getList().then(r => r.data),
      ).preloadOnMount(),

      vehiclesSource: this.$core.loader.select<Vehicle>(({ vehicleType }) =>
        vehicleType ? VehiclesService.getList({ vehicleTypeId: vehicleType.id }) : []
      )
        .dependsOn({ vehicleType: () => this.localTransportRoute.vehicleType })
    };
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localTransportRoute = await TransportRoutesService.get(this.id);
      }
      else {
        this.localTransportRoute = TransportRoute.fromNew();
      }
    },

    async onSubmit(): Promise<void> {
      let success: boolean;

      if (this.localTransportRoute!.isExisting) {
        success = await TransportRoutesService.update(this.localTransportRoute!);
      }
      else {
        success = await TransportRoutesService.add(this.localTransportRoute!);
      }

      if (success) {
        this.$core.dialogs.TransportRouteCard.resolve();
      }
    },
  },
});
</script>
